

// export default Login
import React, { useState, useEffect, useMemo } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import AttestaaiLogo from "../Assets/images/attestaai-logo.png";
import IndexVideo from "../Assets/images/video/feature-2.mp4";

import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useFormik } from 'formik';
import * as Yup from 'yup';
//pass request back end
import axios from "axios";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEye, faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import Logo from "../Assets/images/fav-icon.png";
import UserProfile from "../Assets/images/single-user.png";


import { API_BASE_URL, fetchOptionsInsights } from "../../global";

import LoadingPage from '../LoadingPage/LoadingPage'

const Login = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [optionsInsights, setOptionsInsights] = useState([]);
  useEffect(() => {
    if (!localStorage.getItem("userid")) {
      // enter ths login 
      // toast.error("eNTERES ");
    } else {
      // redirect to dashboard
      navigate('/welcome');
    }
  }, [location])
  useEffect(() => {
    const loadInsights = async () => {
      // const insights = await fetchOptionsInsights();
      // setOptionsInsights(insights);
    };

    loadInsights();
  }, []);

  const [userData, setuserData] = useState(null)
  const [userType, setuserType] = useState(null)
  const [userEmail, setuserEmail] = useState(null)
  const [isSubmitting, setIsSubmitting] = useState(false)
  const [isSubmittingUser, setIsSubmittingUser] = useState(false)
  const [isContentDiv, setIsContentDiv] = useState(1)
  const [loading, setLoading] = useState(false)
  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      email: ""
    },
    validationSchema: Yup.object({
      email: Yup.string().email("Invalid email format").required("Email is required")
    }),
    onSubmit: async values => {
      // console.log(values);
      //disable login button
      setIsSubmitting(true)

      try {
        const response = await axios.post(
          API_BASE_URL + "login",
          {
            ...values
          }
        )

        //setIsContentDiv(2);
        if (response.data && response.data.status && response.data.status == 1) {
          setuserData(response.data.user_id)
          setuserEmail(values.email)
          setuserType(1);
          // DIRECT PASSWORD 
          setIsContentDiv(2);
          setIsSubmitting(false)

        } else if (response.data && response.data.status && response.data.status == 2) {
          setuserData(response.data.user_id)
          setuserEmail(values.email)
          setuserType(2);
          // CONNFIRM  PASSWORD 
          setIsContentDiv(2);
          setIsSubmitting(false)
        } else if (response.data && (response.data.status === 0 || response.data.status === "0")) {
          setuserEmail(null)
          toast.error(response?.data?.message || "The entered email id is wrong.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmitting(false)
        } else {
          setuserEmail(null)
          toast.error("The entered email id is wrong.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmitting(false)
        }
      } catch (error) {
        toast.error("The entered email id is wrong.", {
          autoClose: 3000, // 3 seconds in this example
        })
        console.error("Error fetching data:", error)

        setIsSubmitting(false) // Re-enable the submit button
      } finally {
        setIsSubmitting(false) // Re-enable the submit button
      }

      //dispatch(loginUser(values, props.router.navigate));
    },
  })

  const [showPassword, setShowPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const togglePassword = () => {
    setShowPassword(!showPassword);
  };
  const toggleConfirmPassword = () => setShowConfirmPassword(!showConfirmPassword);

  const validationSchema = Yup.object().shape({
    password: Yup.string()
      .required("Password is required")
      .min(5, "Minimum 5 characters is required")
      .max(30, "Maximum 30 characters is allowed")
      .matches(
        /^(?![,\s])(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+,.\s-]{3,}(?<![,\s])$/,
        "Must have A-Z, a-z, special char, no space/comma at ends"
      ),
    confirmPassword: Yup.string().when('userType', {
      is: (value) => value === 2, // Change condition based on your use case
      then: (schema) =>
        schema
          .required('Confirm Password is required')
          .oneOf([Yup.ref('password')], 'Passwords must match'),
      otherwise: (schema) => schema.notRequired(),
    }),
  });

  const formikConfig = useMemo(() => ({
    enableReinitialize: true,
    initialValues: {
      password: '',
      confirmPassword: '',
      user_id: userData,
      userType: userType,
    },
    validationSchema,
    onSubmit: async values => {
      // console.log(values);
      //disable login button
      setIsSubmitting(true)

      try {
        const response = await axios.post(
          API_BASE_URL + "pwd",
          {
            ...values
          }
        )

        //setIsContentDiv(2);
        if (response.data && response.data.status && response.data.status == 1) {
          localStorage.setItem("username", response.data.user_name)
          localStorage.setItem("useremail", response.data.user_email)
          localStorage.setItem("userid", response.data.user_id)
          localStorage.setItem("userdocumentlabel", response.data.label || 'Project')
          localStorage.setItem("authtoken", response.data.auth_token || "")

          if (response.data?.user_approval_status === 1) {
            localStorage.setItem("view", "upload");
          } else if (response.data?.user_approval_status === 2 || response.data?.user_approval_status === 0) {
            localStorage.setItem("view", "approvalpage");
          } else if (response.data?.user_approval_status === 3) {
            localStorage.setItem("view", "approvalpage");
          }



          //redirect to dashboard
          navigate('/welcome');
          // setLoading(true);

        } else if (response.data && response.data.status && response.data.status == 2) {
          toast.error("The entered password is wrong.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmitting(false)

        } else if (response.data && response.data.status && response.data.status == 3) {
          //continue name, company name
          setuserData(response.data.user_id)
          localStorage.setItem("authtoken", response.data.auth_token || "")
          setIsContentDiv(3);
          setIsSubmitting(false)
        } else {
          toast.error("The entered password is wrong.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmitting(false)
        }
      } catch (error) {
        toast.error("The entered password is wrong.", {
          autoClose: 3000, // 3 seconds in this example
        })
        console.error("Error fetching data:", error)

        setIsSubmitting(false) // Re-enable the submit button
      } finally {
        setIsSubmitting(false) // Re-enable the submit button
      }

      //dispatch(loginUser(values, props.router.navigate));
    },
  }), [userData, userType]);

  const validationPass = useFormik(formikConfig);

  const validationUser = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,
    initialValues: {
      user_id: userData,
      user_name: "",
      user_company: "",
      // user_insights: []
    },
    validationSchema: Yup.object({
      user_name: Yup.string()
        .required("Name is required")
        .min(3, "Minimum 3 characters is required")
        .max(30, "Maximum 30 characters is required"),
      user_company: Yup.string()
        .required("Company's name is required")
        .min(3, "Minimum 3 characters is required")
        .max(50, "Maximum 50 characters is required"),
      // user_insights: Yup.array()
      //   .min(1, "At least one insight must be selected")
      //   .of(Yup.string().required())
    }),
    onSubmit: async values => {
      // console.log(values);
      //disable login button
      setIsSubmittingUser(true)

      try {
        const response = await axios.post(
          API_BASE_URL + "register",
          {
            ...values
          }
        )
        if (response.data && response.data.status && response.data.status == 1) {
          localStorage.setItem("username", response.data.user_name)
          localStorage.setItem("useremail", response.data.user_email)
          localStorage.setItem("userid", response.data.user_id)
          localStorage.setItem("userdocumentlabel", response.data.label || 'Project')
          localStorage.setItem("view", "upload");
          setLoading(true);
          setIsSubmittingUser(false)
          setTimeout(() => {
            setLoading(false)  // hide loading screen
            navigate('/welcome') // navigate after 3 seconds
          }, 5600)

        } else {
          toast.error("The user details could not be added. Please try again.", {
            autoClose: 3000, // 3 seconds in this example
          })
          setIsSubmittingUser(false)
        }
      } catch (error) {
        toast.error("The user details could not be added. Please try again.", {
          autoClose: 3000, // 3 seconds in this example
        })
        console.error("Error fetching data:", error)

        setIsSubmittingUser(false) // Re-enable the submit button
      } finally {
        setIsSubmittingUser(false) // Re-enable the submit button
      }

      //dispatch(loginUser(values, props.router.navigate));
    },
  })



  const handleContinue = (data) => {
    setIsContentDiv(data + 1)
  };
  const getFirstLetter = (data) => {
    return data && data.trim() ? data.trim().charAt(0).toUpperCase() : "";
  };



  console.log(validationUser)

  if (loading) {
    return <LoadingPage /> // show loading screen while loading
  }

  return (
    <div className="index-page">
      <div className="topbar d-print-none">
        <div className="container-fluid px-1">
          <div className="main-wrapper">
            <div className="user-details-main-wrapper">
              {/* Login */}
              <div className="step1 justify-content-center align-items-center text-center flex-column" id="step1" style={{ display: isContentDiv === 1 ? "block" : "none" }}>
                <div className="home-one-wrapper d-flex justify-content-start align-items-center gap-2">

                  {/* Left Section */}
                  <div className="d-flex flex-column align-items-center justify-content-center w-50 h-100">
                    <img loading="lazy" className="split1-logo" src={AttestaaiLogo} alt="logo"
                      style={{ width: '200px', marginTop: '50px' }} />

                    <div className="split1-cnt d-flex flex-column justify-content-center align-items-center">
                      <h1 className="fw-normal display-6">Welcome! Let’s Start with <br /> Your Email</h1>
                      <p className="fs-4 fw-normal">The modern solution for document management.</p>

                      <div className="card shadow-sm p-4 rounded-4" style={{ width: '100%', maxWidth: '420px' }}>

                        <button className="btn common-btn w-100  justify-content-center align-items-center mb-1" id="nextBtn" style={{ display: 'none' }}>
                          <span className="d-flex align-items-center gap-2" style={{ display: 'none' }}>
                            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 512 512" style={{ display: 'none' }}>
                              <g>
                                <path fill="#0085f7" d="M34.909 448.047h81.455V250.229l-53.338-93.138L0 162.956v250.182c0 19.287 15.622 34.909 34.909 34.909z" />
                                <path fill="#00a94b" d="M395.636 448.047h81.455c19.287 0 34.909-15.622 34.909-34.909V162.956l-62.935-5.865-53.428 93.138v197.818z" />
                                <path fill="#ffbc00" d="m395.636 98.956-47.847 91.303 47.847 59.97L512 162.956v-46.545c0-43.142-49.251-67.782-83.782-41.891z" />
                                <path fill="#ff4131" d="m116.364 250.229-45.593-96.31 45.593-54.963L256 203.683 395.636 98.956v151.273L256 354.956z" />
                                <path fill="#e51c19" d="M0 116.411v46.545l116.364 87.273V98.956L83.782 74.52C49.251 48.629 0 73.269 0 116.411z" />
                              </g>
                            </svg>
                            <span style={{ display: 'none' }}>Login with Gmail</span>
                          </span>
                        </button>



                        <div style={{ margin: "2px 0px", display: 'none' }} >OR</div>
                        <form onSubmit={e => {
                          e.preventDefault()
                          validation.handleSubmit()
                          return false
                        }}
                          action="#">
                          <div className="mb-3 w-100">
                            <label htmlFor="email" className="form-label d-flex align-item-start">Email<span className="text-danger">*</span></label>
                            <input
                              name="email"
                              className="form-control lg-input"
                              placeholder="Enter your personal or work email"
                              type="email"
                              id="email"
                              onChange={validation.handleChange}
                              onBlur={validation.handleBlur}
                              value={validation.values.email || ""}
                              invalid={
                                validation.touched.email &&
                                  validation.errors.email
                                  ? true
                                  : false
                              }
                            />
                            {validation.touched.email &&
                              validation.errors.email ? (<div className="text-danger mb-2 d-flex align-item-start">{validation.errors.email}</div>) : null}
                          </div>

                          <button className="btn common-btn w-100" id="" type='submit' disabled={isSubmitting}>
                            Continue with email
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* Right Section */}
                  <div className="d-flex align-items-center justify-content-center w-50 h-100" style={{ backgroundColor: '#fffcf8' }}>
                    <video muted autoPlay loop loading="lazy" className="img-fluid" aria-label="Attesta Video">
                      <source src={IndexVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                </div>
              </div>
              {/* login end */}
              {/* Password */}
              <div className="step1 justify-content-center align-items-center text-center flex-column" id="step1" style={{ display: isContentDiv === 2 ? "block" : "none" }}>
                <div className="home-one-wrapper d-flex justify-content-start align-items-center gap-2">

                  {/* Left Section */}
                  <div className="d-flex flex-column align-items-center justify-content-center w-50 h-100">
                    <img loading="lazy" className="split1-logo" src={AttestaaiLogo} alt="logo"
                      style={{ width: '200px', marginTop: '50px' }} />

                    <div className="split1-cnt d-flex flex-column justify-content-center align-items-center">
                      <h1 className="fw-normal display-6">Welcome! Let’s Start with <br /> Your Email</h1>
                      <p className="fs-4 fw-normal">The modern solution for document management.</p>

                      <div className="card shadow-sm p-4 rounded-4" style={{ width: '100%', maxWidth: '420px' }}>



                        <form
                          onSubmit={(e) => {
                            e.preventDefault();
                            validationPass.handleSubmit();
                            return false;
                          }}
                          action="#"
                        >
                          {userType === 2 ? (
                            <div className="mb-3 w-100">
                              <h2>Sign Up to Get Started</h2>
                            </div>)
                            :
                            (
                              <div className="mb-3 w-100"><h2>Welcome Back — Sign In</h2></div>
                            )
                          }
                          <div className="mb-3 w-100">
                            <h5>{userEmail}</h5>
                          </div>

                          {/* Password Field */}
                          <div className="mb-3 w-100">
                            <label htmlFor="password" className="form-label d-flex align-item-start">Password<span className="text-danger">*</span></label>
                            <div style={{ position: 'relative' }}>
                              <input
                                type={showPassword ? 'text' : 'password'}
                                name="password"
                                id="password"
                                placeholder="Enter your password"
                                className={`form-control lg-input`}
                                onChange={validationPass.handleChange}
                                onBlur={validationPass.handleBlur}
                                value={validationPass.values.password}
                                invalid={
                                  validationPass.touched.password &&
                                    validationPass.errors.password
                                    ? true
                                    : false
                                }
                                autocomplete="off"
                              />
                              <span
                                onClick={togglePassword}
                                style={{
                                  position: 'absolute',
                                  right: '10px',
                                  top: '50%',
                                  transform: 'translateY(-50%)',
                                  cursor: 'pointer',
                                }}
                              >
                                <FontAwesomeIcon icon={showPassword ? faEyeSlash : faEye} />
                              </span>
                            </div>
                            {validationPass.touched.password && validationPass.errors.password && (
                              <div className="text-danger mb-2 d-flex align-item-start">{validationPass.errors.password}</div>
                            )}
                          </div>

                          {/* Confirm Password (only if userData is null) */}
                          {userType === 2 && (
                            <div className="mb-3 w-100">
                              <label htmlFor="confirmPassword" className="form-label d-flex align-item-start">Confirm Password<span className="text-danger">*</span></label>
                              <div style={{ position: 'relative' }}>
                                <input
                                  type={showConfirmPassword ? 'text' : 'password'}
                                  name="confirmPassword"
                                  id="confirmPassword"
                                  placeholder="Confirm your password"
                                  className={`form-control lg-input`}
                                  onChange={validationPass.handleChange}
                                  onBlur={validationPass.handleBlur}
                                  value={validationPass.values.confirmPassword}
                                  invalid={
                                    validationPass.touched.confirmPassword &&
                                      validationPass.errors.confirmPassword
                                      ? true
                                      : false
                                  }
                                  autocomplete="off"
                                />
                                <span
                                  onClick={toggleConfirmPassword}
                                  style={{
                                    position: 'absolute',
                                    right: '10px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    cursor: 'pointer',
                                  }}
                                >
                                  <FontAwesomeIcon icon={showConfirmPassword ? faEyeSlash : faEye} />
                                </span>
                              </div>
                              {validationPass.touched.confirmPassword && validationPass.errors.confirmPassword && (
                                <div className="text-danger mb-2 d-flex align-item-start">{validationPass.errors.confirmPassword}</div>
                              )}
                            </div>
                          )}

                          <button
                            className="btn common-btn w-100"
                            id="nextBtn"
                            type="submit"
                            disabled={isSubmitting}
                          >
                            {userType === 2 ? 'Sign Up' : 'Sign In'}
                          </button>
                        </form>
                      </div>
                    </div>
                  </div>

                  {/* Right Section */}
                  <div className="d-flex align-items-center justify-content-center w-50 h-100" style={{ backgroundColor: '#fffcf8' }}>
                    <video muted autoPlay loop loading="lazy" className="img-fluid" aria-label="Attesta Video">
                      <source src={IndexVideo} type="video/mp4" />
                      Your browser does not support the video tag.
                    </video>
                  </div>

                </div>
              </div>
              {/* password end */}
              <form onSubmit={e => {
                e.preventDefault()
                validationUser.handleSubmit()
                return false
              }}
                action="#">
                {/* name profile start */}

                <div className="step4 justify-content-center align-items-center flex-column" id="step4" style={{ display: isContentDiv === 3 ? "block" : "none" }}>
                  <div className="home-one-wrapper d-flex justify-content-start flex-column gap-2">
                    {/* Step Header */}
                    <div className="step-header d-flex flex-column align-items-start w-100 gap-2 fw-normal">
                      <img loading="lazy" src={AttestaaiLogo} alt="logo" style={{ width: '200px' }} />
                      What do I call you?
                    </div>

                    {/* Input Field */}
                    <div className="name-input d-flex align-items-center gap-2">
                      <div
                        id="profileCircle"
                        className={`profile-circle ${validationUser.values.user_name.trim().length >= 3 ? 'filled' : 'empty'}`}
                      >
                        {getFirstLetter(validationUser.values.user_name)}
                      </div>

                      <input
                        name="user_name"
                        className="form-control lg-input"
                        placeholder="Enter your name"
                        type="text"
                        id="user_name"
                        onChange={validationUser.handleChange}
                        onBlur={validationUser.handleBlur}
                        value={validationUser.values.user_name || ""}
                        invalid={
                          validationUser.touched.user_name &&
                            validationUser.errors.user_name
                            ? true
                            : false
                        }
                      />

                    </div>
                    {validationUser.touched.user_name &&
                      validationUser.errors.user_name ? (<div className="text-danger mb-2">{validationUser.errors.user_name}</div>) : null}




                    {/* Navigation Button */}
                    <div className="w-100 d-flex justify-content-end">
                      <button
                        className="btn common-btn d-flex align-items-center"
                        id="nextBtn4"
                        onClick={async () => {
                          // Validate only the user_name field first
                          await validationUser.validateField("user_name");
                          // Then get the latest errors reliably
                          const errors = await validationUser.validateForm();
                          const hasError = errors.user_name;

                          if (!hasError) {
                            handleContinue(isContentDiv); // go to next step
                          } else {
                            // Optionally, show error or focus input
                            console.log("Username error:", hasError);
                          }
                        }}
                      >
                        <h5 className="me-2 mb-0">Continue</h5>
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>
                  </div>
                </div>
                {/* name profile end */}
                {/* company Name */}
                <div className="step4 justify-content-center align-items-center flex-column" style={{ display: isContentDiv === 4 ? "block" : "none" }}>
                  <div className="home-one-wrapper d-flex justify-content-start flex-column gap-2">
                    {/* Step Header */}
                    <div className="step-header d-flex flex-column align-items-start w-100 gap-2 fw-normal">
                      <img loading="lazy" src={AttestaaiLogo} alt="logo" style={{ width: '200px' }} />
                      {/* <img loading="lazy" src={Logo} alt="logo" /> */}
                      What's your Company's name?
                    </div>

                    {/* Firm Name Input */}
                    <div className="name-input d-flex align-items-center gap-2">
                      <div
                        className={`profile-circle ${validationUser.values.user_company.trim().length >= 3 ? 'filled' : 'empty'}`}
                      >
                        {getFirstLetter(validationUser.values.user_company)}
                      </div>
                      <input
                        name="user_company"
                        className="form-control lg-input"
                        placeholder="Enter your company's name"
                        type="text"
                        id="user_company"
                        onChange={validationUser.handleChange}
                        onBlur={validationUser.handleBlur}
                        value={validationUser.values.user_company || ""}
                        invalid={
                          validationUser.touched.user_company &&
                            validationUser.errors.user_company
                            ? true
                            : false
                        }
                      />
                    </div>

                    {/* Error Message */}
                    {validationUser.touched.user_company &&
                      validationUser.errors.user_company ? (<div className="text-danger mb-2">{validationUser.errors.user_company}</div>) : null}

                    {/* Navigation Button */}
                    <div className="w-100 d-flex justify-content-end">
                      <button className="btn common-btn d-flex align-items-center"
                        type="submit"
                        disabled={isSubmittingUser}
                        onClick={async (e) => {
                          e.preventDefault();
                          // Validate only the user_name field first
                          await validationUser.validateField("user_company");
                          // Then get the latest errors reliably
                          const errors = await validationUser.validateForm();
                          const hasError = errors.user_company;

                          if (!hasError) {
                            validationUser.handleSubmit();
                          } else {
                            // Optionally, show error or focus input
                            console.log("user_company error:", hasError);
                          }
                        }}
                      >
                        <h5 className="me-2 mb-0">save</h5>
                        <i className="fa-solid fa-arrow-right"></i>
                      </button>
                    </div>

                  </div>
                </div>
                {/* company name end */}
                {/* insert start */}
                {/* <div
                  className="step6 justify-content-center align-items-center flex-column"
                  id="step6" style={{ display: isContentDiv === 5 ? "block" : "none" }}
                >
                  <div className="home-one-wrapper d-flex flex-column justify-content-start align-items-center gap-2">
                    <div className="step-header d-flex flex-column align-items-start gap-2 fw-normal">
                      <img loading="lazy" src={AttestaaiLogo} alt="logo" style={{ width: '200px' }} />
                      Select your persona to personalize your experience
                    </div>
                    <div className="mb-0 w-100 mt-2">
                      <div className="d-flex gap-3 justify-content-center flex-wrap">
                        {optionsInsights.map(({ pk_ins_id, ins_name, icon, image, is_active, description }) => {
                          if (is_active === 1) {
                            const isSelected = validationUser.values.user_insights.includes(pk_ins_id);
                            return (
                              <div
                                className={`avatar-items position-relative ${isSelected ? 'active' : ''}`}
                                key={pk_ins_id}
                                onClick={() => {
                                  const prev = validationUser.values.user_insights;
                                  const newValue = isSelected ? [] : [pk_ins_id];
                                  validationUser.setFieldValue("user_insights", newValue);
                                }}
                              // onClick={() => {
                              //   const prev = validationUser.values.user_insights;
                              //   validationUser.setFieldValue(
                              //     "user_insights",
                              //     isSelected
                              //       ? prev.filter((v) => v !== pk_ins_id)
                              //       : [...prev, pk_ins_id]
                              //   );
                              // }}
                              >
                                <div className="text-center">
                                  <img src={image || UserProfile} alt="Paralegal icon" />
                                  <div dangerouslySetInnerHTML={{ __html: description }}></div>
                                </div>
                                <div className="selected">
                                  <i className="fa-solid fa-check"></i>
                                </div>
                              </div>
                            );
                          } else {
                            return (
                              <div className="avatar-items disable position-relative" key={pk_ins_id}>
                                <div className="ribbon-cust">
                                  <span className="ribbon-text text-white text-center">Coming Soon</span>
                                </div>
                                <div className="text-center">
                                  <img src={image || UserProfile} alt="Paralegal icon" />
                                  <div dangerouslySetInnerHTML={{ __html: description }}></div>
                                </div>
                              </div>
                            );
                          }
                        })}

                       
                        <div className="avatar-items disable position-relative">
                          <div className="text-center d-flex flex-column justify-content-center h-100">
                            <h6
                              className="mb-0 text-muted"
                              style={{ fontWeight: 500, fontSize: "18px", color: "#333" }}
                            >
                              More to be<br />Revealed Soon
                            </h6>
                          </div>
                        </div>
                      </div>
                    
                      {validationUser.touched.user_insights &&
                        validationUser.errors.user_insights ? (<div className="text-danger mt-1 mb-2">{validationUser.errors.user_insights}</div>) : null}
                    
                      <div className="w-100 d-flex justify-content-end">
                        <button className="btn common-btn d-flex align-items-center" type='submit' disabled={isSubmittingUser}>
                          <h5 className="me-2 mb-0">Save</h5>
                          <i className="fa-solid fa-arrow-right"></i>
                        </button>
                      </div>

                    </div>
                  </div>
                </div> */}
                {/* insert ent */}
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
